import React from 'react'
import Icon from '@ant-design/icons'
import { AntdIconProps } from '@ant-design/icons/es/components/AntdIcon'

const UserGuideSvg = () => {
  return (
    <svg
      id='prefix__Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x={0}
      y={0}
      viewBox='0 0 67 49'
      xmlSpace='preserve'
      width='50px'
      height='50px'
    >
      <style>{'.prefix__st0{fill:#bac5d4}'}</style>
      <path className='prefix__st0' d="M11,11.1c0-.3-.3-.6-.6-.6h-4.7c-.3,0-.6.3-.6.6s.3.6.6.6h4.7c.3,0,.6-.3,.6-.6Z"/>
      <path className='prefix__st0' d="M5.7,6.8h9.3c.3,0,.6-.3.6-.6s-.3-.6-.6-.6H5.7c-.3,0-.6.3-.6.6s.3.6.6.6Z"/>
      <path className='prefix__st0' d="M8.5,15.5h-2.8c-.3,0-.6.3-.6.6s.3.6.6.6h2.8c.3,0,.6-.3,.6-.6s-.3-.6-.6-.6Z"/>
      <path className='prefix__st0' d="M8.5,20.5h-2.8c-.3,0-.6.3-.6.6s.3.6.6.6h2.8c.3,0,.6-.3,.6-.6s-.3-.6-.6-.6Z"/>
      <path className='prefix__st0' d="M20.9,10.7v-6.5C20.9,1.9,19,0,16.7,0H4.2C1.9,0,0,1.9,0,4.2v17.7C0,24.2,1.9,26,4.2,26h10.8c.1,0,.2,0,.3-.1,1,.4,2,.6,3.2.6,4.5,0,8.1-3.6,8.1-8.1s-2.4-6.7-5.7-7.7ZM4.2,24.8c-1.6,0-2.9-1.3-2.9-2.9V4.2c0-1.6,1.3-2.9,2.9-2.9h12.6c1.6,0,2.9,1.3,2.9,2.9v6.3c-.4,0-.7,0-1.1,0-4.5,0-8.1,3.6-8.1,8.1s1.2,4.8,3,6.3H4.2ZM18.5,25.3c-3.8,0-6.8-3.1-6.8-6.8s3.1-6.8,6.8-6.8,6.8,3.1,6.8,6.8-3.1,6.8-6.8,6.8Z"/>
      <path className='prefix__st0' d="M18.5,17.6c-.3,0-.6.3-.6.6v3.3c0,.3.3.6.6.6s.6-.3.6-.6v-3.3c0-.3-.3-.6-.6-.6Z"/>
      <path className='prefix__st0' d="M18.1,15.8c.1.1.3.2.5.2s.2,0,.2,0c0,0,.2,0,.2-.1,0,0,.1-.1.1-.2,0,0,0-.2,0-.2s0-.2,0-.2c0,0,0-.2-.1-.2-.2-.2-.7-.2-.9,0,0,0-.1.1-.1.2,0,0,0,.2,0,.2s0,.2,0,.2c0,0,0,.2.1.2Z"/>
    </svg>
  )
}

export const UserGuideIcon = (props: AntdIconProps) => (
  <Icon component={UserGuideSvg} {...(props as any)} />
)

